var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({class:[_vm.className, 'icon'],domProps:{"innerHTML":_vm._s(_vm.getIcon)}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }